import { render, staticRenderFns } from "./WebsiteArticle.vue?vue&type=template&id=3ea3103c&scoped=true&"
import script from "./WebsiteArticle.vue?vue&type=script&lang=js&"
export * from "./WebsiteArticle.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteArticle.vue?vue&type=style&index=0&id=3ea3103c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea3103c",
  null
  
)

export default component.exports